import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import FaceSadIcon from '~/components/atoms/icon/faceSad/FaceSadIcon';
import InstantSearchAllResults from '~/components/molecules/instantSearch/InstantSearchAllResults';
import styles from '~/components/molecules/noResults/noResults.module.scss';
import instantStyles from '~/components/organisms/instantSearch/instantSearch.module.scss';
import { QuerySetContextProvider } from '~/contexts/QuerysetContext';
import { useConfig } from '~/core/configuration/configContext';
import { InstantSearchDisplayType } from '~/core/configuration/configuration-global-config.type';
import { useSERPState } from '~/core/state/SERPStateContext';
import { ProductResults_State } from '~/core/state/types/state-results.schema';
import { GoToResultHandler } from '~/hooks/useGoToResult';
import { ProductResultContainer } from '../../products/productSingleResult/productResultContainer';
import ProductSingleResult from '../../products/productSingleResult/ProductSingleResult';
import productStyles from './instantProducts.module.scss';

interface IInstantProductResultsProps {
    openFullSERP: () => void;
    displayType?: InstantSearchDisplayType;
    handleGoToResult: GoToResultHandler;
}

const InstantProductResults: React.FC<IInstantProductResultsProps> = ({
    openFullSERP,
    displayType,
    handleGoToResult,
}) => {
    const state = useSERPState();
    const config = useConfig();
    const productsState = state.sets.find((set) => set.layoutPosition === 'serp-products');
    const resultCount = 8;

    //TODO: move to util function to remove redundant code
    const productsResults = state.results.sets.find(
        (set) => set.querySetIdentifier === productsState?.querySet.identifier
    ) as ProductResults_State;

    //TODO: not yet implemented on backend
    const topProduct = productsResults?.hits[0];
    if (topProduct) {
        topProduct.isTopProduct = true;
    }

    if (!productsState) {
        return null;
    }

    if (!productsResults || productsResults.hits.length === 0) {
        return (
            <div className={productStyles.instantProductResultsWrapper} data-testid="instantsearch-module-wrapper">
                <div className={styles.noResults}>
                    <div>
                        <FaceSadIcon />
                    </div>
                    <div role="paragraph">
                        <FormattedMessage
                            id="no_result"
                            defaultMessage="Bohužel jsme nenašli žádné výsledky. Zkuste upravit vaše zadání."
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={productStyles.instantProductResultsWrapper} data-testid="instantsearch-module-wrapper">
            <div
                role="heading"
                aria-level={2}
                className={instantStyles.instantResultsTitle}
                data-testid="instantsearch-module-title"
            >
                <FormattedMessage id="products_title" defaultMessage="Produkty" />
            </div>
            <div
                className={classNames(
                    productStyles.instantProductResults,
                    displayType === 'grid' && productStyles.instantProductResultsGrid
                )}
            >
                <QuerySetContextProvider querySetId={productsState.querySet.identifier}>
                    {productsResults?.hits.slice(0, resultCount).map((product, index: number) => (
                        <ProductResultContainer
                            isInstantSearch={true}
                            key={index}
                            result={product}
                            order={index}
                            customColorsConfiguration={{
                                labels: config.layout.configuration.labels,
                                deliveries: config.layout.configuration.deliveries,
                            }}
                            handleGoToResult={handleGoToResult}
                            productStyles={productStyles}
                        >
                            <ProductSingleResult />
                        </ProductResultContainer>
                    ))}
                </QuerySetContextProvider>
            </div>
            <InstantSearchAllResults openFullSERP={openFullSERP} />
        </div>
    );
};

export default InstantProductResults;
